<template lang="html">
	<div class="component transformproperties">
		<div class="script-name">
			<div style="padding: 4px;display: inline-block;"><i class="icon-device_hub"></i> <span>Transform</span></div>
		</div>
		<div class="script-properties">
			<div v-for="(label, variable) in {position: 'position', rotation: 'rotation', scale: 'scale'}" :key="variable" style="font-size: 14px;padding: 5px;">
				<label style="margin: 0;color: inherit;background: none;display: block;padding: 6px 0;">{{label}}</label>
				<div style="display: flex;">
					<div v-for="(coord, label) in modelValue[variable]" :key="label" class="input-group" style="margin-right: 7px;">
						<input type="text" :value="coord" @input="$event.target.value = $event.target.value.replace(/[^0-9.\-]/g, '') || 0" @change="change(variable, label, $event.target.value)">
						<span class="input-group-append">{{label}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['modelValue'],
	emits: ['update:modelValue'],
	methods: {
		change: function (variable, coord, value) {
			this.modelValue[variable][coord] = parseFloat(value) || 0;
			this.$emit('update:modelValue', this.modelValue);
		}
	}
}
</script>
